const DEFAULT_API_BASE_URL = import.meta.env.DEV ? '/api' : 'https://api.jemmi.fun';
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? DEFAULT_API_BASE_URL).replace(/\/$/, '');

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
  }
}

type ApiErrorEnvelope = {
  ok: false;
  error?: {
    code?: string;
    message?: string;
  };
};

type ApiSuccessEnvelope<T> = {
  ok: true;
  data: T;
};

export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body !== undefined && !(init.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers,
    credentials: 'include',
  });

  let payload: ApiSuccessEnvelope<T> | ApiErrorEnvelope | null = null;
  try {
    payload = (await response.json()) as ApiSuccessEnvelope<T> | ApiErrorEnvelope;
  } catch {
    // Preserve a useful error even if an upstream failure returns HTML/plain text.
  }

  if (!response.ok || !payload || payload.ok !== true) {
    const errorPayload = payload && payload.ok === false ? payload.error : undefined;
    throw new ApiError(
      response.status,
      errorPayload?.code ?? 'request_failed',
      errorPayload?.message ?? 'Request failed. Please try again.',
    );
  }

  return payload.data;
}
